import { ComponentProps } from 'react';
import { vars } from 'src/core/themes';
import { IconsFill, SuccessOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ButtonWithIcon } from './ButtonWithIcon';

export const ConfirmButton = ({
  textContentId,
  iconOnlyMode,
  variant,
  icon,
  ...props
}: ComponentProps<typeof ButtonWithIcon>) => {
  return (
    <ButtonWithIcon
      {...props}
      icon={
        icon ?? (
          <SuccessOutlineIcon
            withHoverEffect
            fill={
              iconOnlyMode || (variant && variant !== 'regular')
                ? IconsFill.textSuccess
                : IconsFill.textInverted
            }
            size={vars.iconSize.m}
          />
        )
      }
      iconOnlyMode={iconOnlyMode}
      variant={variant}
      textContentId={textContentId || ContentId.ConfirmSale}
    />
  );
};
